import { isGlobalFeatureEnabled } from "owa-feature-flags";
import shouldUseOutlookKeyboardShortcuts from "owa-hotkeys/lib/utils/shouldUseOutlookKeyboardShortcuts";

export function shouldUseLocalizedFormatting(): boolean {
    return (isGlobalFeatureEnabled("cmp-localization-shortcut", true /* dontThrowErrorIfNotInitialized */) && shouldUseOutlookKeyboardShortcuts());
}
